import type { MouseEvent } from 'react'

/** A tap on the dimmed screen around a sheet (its backdrop is part of the dialog) closes it; a tap inside never does. */
export const closeOnOutsideTap = (event: MouseEvent<HTMLDialogElement>) => {
  const dialog = event.currentTarget
  if (event.target !== dialog) return
  const box = dialog.getBoundingClientRect()
  if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close()
}
